import React from "react";
import { createPortal } from "react-dom";
import { CertificateMatch, CertificateMatchList } from "./LegacyCertList";

type CertificateResult = {
  blanccoHits: number;
  certusHits: number;
  legacyHits: number;
  matches: CertificateMatch[];
  warnings?: string[];
};

interface Props {
  result: CertificateResult;
  onClose: () => void;
}

export const CertificateResultModal: React.FC<Props> = ({ result, onClose }) => {
  return createPortal(
    <div
      className="gw-modal-overlay"
      style={{ zIndex: 12000 }}
      onClick={onClose}
    >
      <div
        className="gw-modal-card gw-modal-card--cert-results p-5 flex flex-col max-h-[80vh]"
        style={{ zIndex: 12001 }}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-start justify-between gap-3 mb-3 pr-1">
          <div>
            <h3 className="gw-modal-title m-0">Sökresultat certifikat</h3>
            <div>Blancco: {result.blanccoHits} träffar</div>
            <div>Certus: {result.certusHits} träffar</div>
            <div>Legacy: {result.legacyHits} träffar</div>
            {result.warnings?.map((warning) => <div role="alert" className="text-error" key={warning}>{warning}</div>)}
            {result.matches.length === 0 && (
              <div className="text-muted">Ingen PDF hittades.</div>
            )}
          </div>
          <button type="button" className="gw-btn gw-btn-ghost gw-btn-xs" onClick={onClose} aria-label="Stäng">
            Stäng
          </button>
        </div>

        <div className="flex-1 overflow-y-auto pr-1">
          {result.matches.length > 0 ? (
            <CertificateMatchList matches={result.matches} />
          ) : (
            <div className="text-muted">Ingen PDF hittades.</div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};
